import {
  clearListFilters,
  readListFilters,
  writeListFilters,
} from "./listFilterStorage";
import { rolesCompanyScope } from "./listFilterScopes";

const DEFAULT_INTERVIEW_MESSAGING = ["Active", "Inactive", "Needs Setup"];

const LEGACY_INTERVIEW_MESSAGING = {
  On: "Active",
  Paused: "Inactive",
  "Needs Questions": "Needs Setup",
};

export function readRolesListFilters(companyId) {
  const scope = rolesCompanyScope(companyId);
  const raw = scope ? readListFilters(scope) : null;
  if (!raw) return null;
  return normalizeRolesListFilters(raw);
}

export function writeRolesListFilters(companyId, payload) {
  const scope = rolesCompanyScope(companyId);
  if (scope) writeListFilters(scope, payload);
}

export function clearRolesListFilters(companyId) {
  const scope = rolesCompanyScope(companyId);
  if (scope) clearListFilters(scope);
}

export function normalizeRolesListFilters(raw) {
  const interviewMessagingFilter = Array.isArray(raw.interviewMessagingFilter)
    ? [
        ...new Set(
          raw.interviewMessagingFilter
            .filter((value) => typeof value === "string")
            .map((value) => LEGACY_INTERVIEW_MESSAGING[value] || value)
        ),
      ]
    : DEFAULT_INTERVIEW_MESSAGING;
  return {
    roleSearchQuery:
      typeof raw.roleSearchQuery === "string" ? raw.roleSearchQuery : "",
    interviewMessagingFilter,
    autoSendFilter:
      raw.autoSendFilter === "on" ||
      raw.autoSendFilter === "off" ||
      raw.autoSendFilter === "all"
        ? raw.autoSendFilter
        : "all",
    rolePurposeFilter:
      typeof raw.rolePurposeFilter === "string" ? raw.rolePurposeFilter : "all",
    currentPage:
      typeof raw.currentPage === "number" && raw.currentPage >= 1
        ? raw.currentPage
        : 1,
    sortField: typeof raw.sortField === "string" ? raw.sortField : null,
    sortDirection:
      raw.sortDirection === "asc" || raw.sortDirection === "desc"
        ? raw.sortDirection
        : null,
  };
}

export { DEFAULT_INTERVIEW_MESSAGING };
